import * as Yup from 'yup';

import { Organization } from '@/api/organizations/models/Organization';
import { FMSTexts } from '@/types/fms';

export interface OrganizationUserFormValues {
  email: string | undefined;
  givenName: string;
  familyName: string;
  organizations?: Organization[];
  roles: string[];
}

const organizationSchema = (): Yup.SchemaOf<Organization> =>
  Yup.object({
    organizationId: Yup.string().required(),
    organizationName: Yup.string().required(),
    numberOfUsers: Yup.number(),
  });

export const getValidationSchemaEditAllUsers = (
  texts: FMSTexts,
): Yup.SchemaOf<OrganizationUserFormValues> =>
  Yup.object({
    givenName: Yup.string().required(texts.form.emptyMessage),
    familyName: Yup.string().required(texts.form.emptyMessage),
    email: Yup.string().email(texts.form.invalidEmail),
    organizations: Yup.array().of(organizationSchema().required()),
    roles: Yup.array().of(Yup.string().required()),
  });

export const getValidationSchemaAddAllUsers = (
  texts: FMSTexts,
): Yup.SchemaOf<OrganizationUserFormValues> =>
  Yup.object({
    givenName: Yup.string().required(texts.form.emptyMessage),
    familyName: Yup.string().required(texts.form.emptyMessage),
    email: Yup.string()
      .required(texts.form.emptyMessage)
      .email(texts.form.invalidEmail),
    organizations: Yup.array()
      .of(organizationSchema().required())
      .required(texts.form.emptyMessage),
    roles: Yup.array()
      .of(Yup.string().required())
      .min(1, texts.form.emptyMessage),
  });

export const getValidationSchemaAddOrganizationUsers = (
  texts: FMSTexts,
): Yup.SchemaOf<OrganizationUserFormValues> =>
  Yup.object({
    givenName: Yup.string().required(texts.form.emptyMessage),
    familyName: Yup.string().required(texts.form.emptyMessage),
    email: Yup.string()
      .required(texts.form.emptyMessage)
      .email(texts.form.invalidEmail),
    organizations: Yup.array().of(organizationSchema().required()),
    roles: Yup.array()
      .of(Yup.string().required())
      .min(1, texts.form.emptyMessage),
  });

export const getValidationSchemaEditOrganizationUsers = (
  texts: FMSTexts,
): Yup.SchemaOf<OrganizationUserFormValues> =>
  Yup.object({
    givenName: Yup.string().required(texts.form.emptyMessage),
    familyName: Yup.string().required(texts.form.emptyMessage),
    email: Yup.string().email(texts.form.invalidEmail),
    organizations: Yup.array().of(organizationSchema().required()),
    roles: Yup.array()
      .of(Yup.string().required())
      .min(1, texts.form.emptyMessage),
  });

interface TextInputSetting {
  disabledRules: {
    editOrganization: boolean;
    editAll: boolean;
    addOrganization: boolean;
    addAll: boolean;
  };
}

interface TextInputSettings {
  givenName: TextInputSetting;
  familyName: TextInputSetting;
  email: TextInputSetting;
}

export const textInputSettings: TextInputSettings = {
  givenName: {
    disabledRules: {
      editOrganization: false,
      editAll: true,
      addOrganization: false,
      addAll: false,
    },
  },
  familyName: {
    disabledRules: {
      editOrganization: false,
      editAll: true,
      addOrganization: false,
      addAll: false,
    },
  },
  email: {
    disabledRules: {
      editOrganization: true,
      editAll: true,
      addOrganization: false,
      addAll: false,
    },
  },
};
